

import { v4 as uuidv4, v4 } from 'uuid';
import { deadlineObjectChecker, deadlinesData, deviceAndNonConfId, deviceSubstitutionStatus, filterActiveStatus, futureDeadlinesData, unique } from '../../lib/utils';
import { deviceNonConformityDoc, deviceExpandedDoc } from '../../components/gestioneDatabase/Docs';
import deadlines from '../Deadlines';


/**
 * MAIN FUNCTION: Generates comprehensive offer data for pricing and quotation purposes
 * #offers #offerGenration
 * This is the core function that processes device non-conformities, customer products,
 * labor costs, and pricing to generate a complete offer structure. It handles complex
 * business logic including:
 * - Non-conformity to product matching
 * - Labor calculation based on device types  
 * - Pricing with discounts and margins
 * - Waste management (formulario) requirements
 * - Product substitutions and supplies
 * - Duplicate handling and prioritization
 * 
 * @param {Object} data - Complete dataset required for offer generation
 * @param {Object} data.registerTemplate - Device register template defining device characteristics
 * @param {Array} data.customerProducts - Available customer products with pricing
 * @param {Object} data.client - Client information including discount rates
 * @param {Object} data.priceList - Price list with customer-specific pricing
 * @param {Array} data.nonConformities - Non-conformities found during inspection
 * @param {Object} data.register - Device register containing device information
 * @param {String} data.siteId - Unique identifier for the inspection site
 * 
 * @returns {Object} Object of structured offer data with pricing, quantities, and descriptions
 * @throws {Error} Logs errors to console and returns empty array on failure
 * 
 * @example
 * const offer = offerData({
 *   registerTemplate: deviceTemplate,
 *   customerProducts: availableProducts,
 *   client: clientInfo,
 *   priceList: pricingData,
 *   nonConformities: foundIssues,
 *   register: deviceRegister,
 *   siteId: "site-123"
 * });
 */
export const registerData = (data={}) => {
    const {register, priceList, offer, registerTemplates, nonConformities, customerProducts, sUser, client, offers, customYear} = data

    // Find offerFields with order
    //const siteOffers = offers?.filter?.((x)=>x?.site?._ref == register?.site?._ref)
    //const siteAllOfferFields = !Array.isArray(siteOffers) ? [] : siteOffers?.map?.((x)=>x?.offerFields).flat()
    //const siteAllOfferFieldsOrdered = !Array.isArray(siteAllOfferFields) ? [] : siteAllOfferFields?.filter?.((x)=>x?.clientOrder?._ref)
    //const siteAllOfferFieldsNotOrdered = !Array.isArray(siteAllOfferFields) ? [] : siteAllOfferFields?.filter?.((x)=>!x?.clientOrder?._ref)

    
    const registerTemplate = !Array.isArray(registerTemplates) ? undefined : registerTemplates?.find?.((x)=>x?._id == register?.template?._ref)
    const registerTemplateDevices = registerTemplate?.devices
    const devicesFilter = (device)=>{
        //if(deviceFamily) return device?.templateDevice?._ref == deviceFamily?.templateDeviceId && device?.status !== "ARCHIVIATO"
        return device?.status !== "ARCHIVIATO" && device?.status !== "COMPLETATO"
    }
    const registerDevices = !Array.isArray(register?.devices) ? [] : register?.devices?.filter?.(devicesFilter).map?.((item)=>deviceExpandedDoc(item))
    const supplyDevices = !Array.isArray(register?.devices) ? [] : register?.devices?.filter?.(device=>device?.status == "DA FORNIRE").map?.((item)=>deviceExpandedDoc(item))
    const futureDeadlines = registerDevices?.map?.((item)=>futureDeadlinesData(item, registerTemplate, sUser, customYear)).filter?.((x)=>x).flat()
    const currentDeadlines = registerDevices?.map?.((item)=>deadlinesData(item, registerTemplate, sUser)).filter?.((x)=>x).flat()
    const allDeadlines = customYear ? futureDeadlines : currentDeadlines
    //if(futureDeadlines?.length && customYear) console.log("NON CONFORMITY DEADLINE joweidjewoidj", {futureDeadlines})
   
    const registerDeviceNonConformities = registerDevices?.map?.((item)=>{
        const nonConformities = item?.nonConformities?.map?.((nc)=>({...nc, device: deviceExpandedDoc(item, nc)}))
        return nonConformities?.length>0 ? nonConformities : []
    })?.flat()

/*     const filterOrderedDeviceNonConformities = (deviceNonConformity) => {

        return !siteAllOfferFieldsOrdered?.some?.((x)=>x?.deviceNonConformityId == deviceNonConformity?._id)
    } */
    const alldeviceNonConformities = [...!Array.isArray(registerDeviceNonConformities) ? [] : registerDeviceNonConformities?.filter?.(filterActiveStatus)]
   // console.log("NON CONF IN CONSOLE:", alldeviceNonConformities)
    
    const uniqueDeadlines = unique("_id", allDeadlines)
   
    const deadlineNonConformities = uniqueDeadlines?.map?.((deadline)=>{
        const nonConformityId = deadline?.nonConformity?._ref
        const nonConformity = !Array.isArray(nonConformities) ? {} : nonConformities?.find?.((x)=>x?._id == nonConformityId)
        let doc = {
            ...nonConformity,
            deviceNonConformities: allDeadlines?.filter?.((x => x?._id == deadline?._id))
        }
        //delete doc.device
        return doc
    })
    
    //console.log("lajncalwkjnclk", {siteOffers, siteAllOfferFields, siteAllOfferFieldsOrdered, siteAllOfferFieldsNotOrdered, alldeviceNonConformities, filteredAlldeviceNonConformities:alldeviceNonConformities?.filter?.(filterOrderedDeviceNonConformities) })
 
    const subFilter = (device) => {
        const deadlineSubDevices = !Array.isArray(deadlineNonConformities) ? [] : deadlineNonConformities?.filter?.((x)=>x?.substitution)
            ?.map?.((item)=>item?.deviceNonConformities)
            ?.flat()
            ?.map?.((dNc)=>dNc?.device)
        
        const expiry = deadlines(device, registerTemplate)
    
        //console.log("CONSOLE:", deadlineSubDevices, device?._id)
        const isAlreadyInDeadlines = deadlineSubDevices?.some?.((y=>y?._id == device?._id))
        const deviceStatus = deviceSubstitutionStatus({deviceStatus: device?.status, device, deadlines: expiry, client})

        return deviceStatus == "DA SOSTITUIRE" && !isAlreadyInDeadlines
    }
    const subDevices = !Array.isArray(register?.devices) ? [] : register?.devices?.filter?.(subFilter).map?.((item)=>deviceExpandedDoc(item))
   
    const subNonConformity = {
        ...!Array.isArray(nonConformities) ? {} : nonConformities?.find?.((x)=>x?._id == "5a6de70d-8353-4209-8eb9-cb62f5554d4a"),
        deviceNonConformities: subDevices?.map?.((device)=>({
            device,
            ...deviceNonConformityDoc("5a6de70d-8353-4209-8eb9-cb62f5554d4a", sUser),
            _id: deviceAndNonConfId(device?._id, "5a6de70d-8353-4209-8eb9-cb62f5554d4a"),
            //status:"DA FARE",
           // _key: keyId(),
            //nonConformity:{_ref:"5a6de70d-8353-4209-8eb9-cb62f5554d4a",_type:"reference", _key: keyId()}
        }))
        }
    
    const findSupplyNonConformity = !Array.isArray(nonConformities) ? undefined : nonConformities?.find?.(x=>x?._id == registerTemplate?.supplyNonConformity?._ref) 
    const supplyNonConformityId = findSupplyNonConformity?._id ? findSupplyNonConformity?._id : "1fb94887-ddb6-441c-90a8-00770f2e6e23"

    const supplyNonConformity = {
        ...!Array.isArray(nonConformities) ? {} : nonConformities?.find?.((x)=>x?._id == supplyNonConformityId),
        deviceNonConformities: supplyDevices?.map?.((device)=>({
            device,
            ...deviceNonConformityDoc(supplyNonConformityId, sUser),
            _id: deviceAndNonConfId(device?._id, supplyNonConformityId),
            //status:"DA FARE",
            //_key: keyId(),
        
        }))
    }
    //if(supplyNonConformity?.deviceNonConformities?.length > 0) console.log("SUPPLY NON CONF:",supplyNonConformity)
    //if(deadlineNonConformities.length>0 && registerTemplate?.family == "ESTINTORI")console.log("REGISTER DEADLINES:",deadlineNonConformities)

    const registerNonConformities = !Array.isArray(nonConformities) ? [] : nonConformities?.filter?.((y)=>Array.isArray(alldeviceNonConformities) && alldeviceNonConformities?.some?.((x)=>x?.nonConformity?._ref == y?._id)).map?.((item)=>({
        ...item,
        deviceNonConformities: !Array.isArray(alldeviceNonConformities) ? [] : alldeviceNonConformities?.filter?.((x)=>x?.nonConformity?._ref == item?._id)
    }))
   
    const registerNonConformitiesArray = registerNonConformities ? registerNonConformities : []
    
    //console.log("SUB:", registerNonConformities)
    const allNonConformities = [
        ...registerNonConformitiesArray, 
        ...deadlineNonConformities, 
        subNonConformity?.deviceNonConformities?.length > 0 && subNonConformity, 
        supplyNonConformity?.deviceNonConformities?.length > 0 && supplyNonConformity
    ].filter?.((x)=>x)
    //console.log("DEADLINES:", deadlineNonConformities)
    //console.log("CONSOLE:", allNonConformities)
    //CUSTOMER PRODUCTS LOGIC


    const customerProductFilter = (customerProduct, registerTemplate) => {
        const isRegister = customerProduct?.registers?.some?.((x)=>x?._ref == registerTemplate?._id)
        return isRegister
    }
        // DEADLINES
                    
        const deadlinesCustomerProducts = []
        const registerCustomerProducts = !Array.isArray(customerProducts) ? [] : customerProducts?.filter?.((x) => customerProductFilter(x, registerTemplate))
        const registerCustomerProductsArray = registerCustomerProducts ? registerCustomerProducts : []

        const customersProductsWithNoRegistersAssigned = !Array.isArray(customerProducts) ? [] : customerProducts?.filter?.((x)=>x?.registers?.length < 1)
        //if(customersProductsWithNoRegistersAssigned)console.log("IN CONSOLE PROD WITH NO REGISTERS", customersProductsWithNoRegistersAssigned)

        const allCustomersProducts = [...registerCustomerProductsArray, ...deadlinesCustomerProducts, ...customersProductsWithNoRegistersAssigned]
        
     
        
        //console.log("SUB:", deviceFamily, allNonConformities)
        const doc = {
            registerTemplate: registerTemplate,
            register,
            siteId: register?.site?._ref,
            devices: registerDevices, 
            nonConformities: allNonConformities,
            //nonConformities,  
            customerProducts:  allCustomersProducts,
            deviceNonConformities: alldeviceNonConformities, 
            templateDevices: registerTemplateDevices,
            customerProductsExist: allCustomersProducts?.length > 0 ? true : false,
            //AAATEST: "STOCAZZO",
            //deviceFamily,
            offer,
            priceList,
            client
        }
    return (doc)

}